import { NO_PORTFOLIOS, LOADING, SUCCESS_PORTFOLIOS, SELECT_PORTFOLIO, SUCCESS_FILTERS, SUCCESS_DATA} from './PortfolioActions';

const INITIAL_STATE = {  
  noPortfolios: false,
  isLoading: false,
  loaded: false,
  settings: {
    dashboards: [],
  },
  portfolios: [],
  filters: {
    dashboards: [],
  },
  stats: {},
  trends: {},
  comparison: {},
  selectedPortfolio: {}
};

const PortfolioReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case NO_PORTFOLIOS: {
      return { ...state, noPortfolios: true, loaded: true, selectedPortfolio:{}, portfolios: [], issue: '' };
    }
    case LOADING: {
      return { ...state, isLoading: action.isLoading };
    }
    case SUCCESS_PORTFOLIOS: {
      return { ...state, isLoading: false, loaded: true, portfolios: action.portfolios };
    }
    case SELECT_PORTFOLIO: {
      return { ...state, isLoading: false, noPortfolios: false, selectedPortfolio: action.selected, viewId: action.viewId,  };
    }
    case SUCCESS_FILTERS: {
      return { ...state, filters: action.filters };
    }
    case SUCCESS_DATA: {
      return { ...state, isLoading: false, stats: action.data.stats, trends: action.data.trends };
    }    
    default:
      return state;
  }
};

export default PortfolioReducer;
